import winston from 'winston';

import { rootLogger } from './root-logger';

export function getLogger(context: string, meta: Record<string, unknown>): winston.Logger {
  return rootLogger.child({
    context,
    ...meta,
  });
}
